import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { TypeDocForm } from 'front-office/components/type-doc/form';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { typeDocCrubs } from 'front-office/constants/type-doc-crubs';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';

const TypeDocEdit = (): React.ReactElement => {
  const insertTypeDoc = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-documento`,
    {
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onOk = (form: TypeDocForm | undefined) => {
    (
      insertTypeDoc({
        data: {
          descrizioneTipoDocumento: form?.description || undefined,
          tipoDiritti: form?.typeRights || undefined,
          modalitaRilascio: form?.mode || undefined,
          codiceTemplate: form?.template || undefined,
          gruppoDocumento: form?.groupDoc || undefined,
          flagDocumentoInUso: form?.isUse ? '1' : '0',
          tipoIntestatario: form?.holderType || undefined,
          //flagIscrittiAire: form?.isAire ? '1' : '0',
          key: {
            tipoDocumento: form?.typeDoc || undefined,
            codiceDocumento: form?.code || undefined,
          },
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/tipo-doc');
    });
  };

  return (
    <Fragment>
      <Breadcrumbs items={[...typeDocCrubs, { name: 'Nuovo Tipo documento' }]} />
      <Form
        title="Nuovo Tipo documento"
        onOk={onOk}
        onCancel={() => {
          navigate('/sportello/tipo-doc');
        }}
      />
    </Fragment>
  );
};

TypeDocEdit.displayName = 'type document edit page component';

export default TypeDocEdit;
